import { createSlice } from "@reduxjs/toolkit";

export interface ConfigState {
  isFetching: boolean;
}

const DEFAULT_STATE: ConfigState = {
  isFetching: true,
};

export const configSlice = createSlice({
  name: "config",
  initialState: DEFAULT_STATE,
  reducers: {
    updateAttributes: (state, { payload }) => {
      return { ...state, ...payload };
    },
    isFetchingConfig: (state, { payload }) => {
      state.isFetching = payload;
    },
  },
});
